import { Field, Form as FormikForm, Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import v4 from 'uuid';
import { Button, Form, Header } from 'semantic-ui-react';
import userACL from '../../../store/access';
import { FormikInputComponent } from '../../../utilities/formUtils';
import Notification from '../../../utilities/notificationUtils';
import { createItemmap, editItemmap, setNotifyDone } from '../data/actions';
import { itemmapSchema } from '../data/model';
import { getItemmap, getItemmapParams, getNotification } from '../data/selectors';
import LedgerSearch from '../../ledger_search/components/LedgerSearch';
import ItemNameSearch from '../../itemName_search/components/ItemNameSearch';
import CommonSelect from '../../common/components/CommonSelect';
import { getCompanyList } from '../../common/data/selectors';
import {
    handleItemWiseSaleLedgerSelection,
    handleItemWiseSaleLedgerOnBlur,
    handleItemWisePurchaseLedgerSelection,
    handleItemWisePurchaseLedgerOnBlur,
    handleItemWiseSTOLedgerSelection,
    handleItemWiseSTOLedgerOnBlur,
    handleItemWiseSTILedgerSelection,
    handleItemWiseSTILedgerOnBlur,
    handleRlbItemNameSelection,
    handleRlbItemNameOnBlur
} from '../functions';

const ItemmapForm = (props) => {
    const itemmap = useSelector(state => getItemmap(state, props))
    const params = useSelector(state => getItemmapParams(state, props))
    const companyOptions = useSelector(state => getCompanyList(state, props))
    const [savedItemmapId, setSavedItemmapId] = useState(false)
    const dispatch = useDispatch()

    const handleSelectChange = (value, setFieldValue, _values, _type, _index, fieldName) => {
        setFieldValue(fieldName, value);
    };

    const saveItemmap = (values, resetForm) => {
        if (props.match.path === '/itemmap/create') {
            userACL.atCreate(values)
            dispatch(createItemmap(values))
            setSavedItemmapId(values.id)
            resetForm()
        }
        if (props.match.path === '/itemmap/edit/:id') {
            userACL.atUpdate(values)
            dispatch(editItemmap(values))
            setSavedItemmapId(values.id)
            setTimeout(function () {
                props.history.push(`/itemmap/list`)
            }, 2000)
        }
        if (props.match.path === '/itemmap/clone/:id') {
            userACL.atCreate(values)
            values.id = v4()
            dispatch(createItemmap(values))
            setSavedItemmapId(values.id)
            setTimeout(function () {
                props.history.push(`/itemmap/list`)
            }, 2000)
        }
    }

    return (
        < >
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 4px 12px",
            }}>
                <div>
                    <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
                        {params.title}
                    </div>
                    <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
                        Fill in the item mapping details below.
                    </div>
                </div>
            </div>
            <Formik id="itemmapForm" size="large" width={5}
                initialValues={itemmap}
                validationSchema={itemmapSchema}
                onSubmit={(values, { resetForm }) => saveItemmap(values, resetForm)}
                render={({ handleSubmit, resetForm, onChange, values, handleChange, setFieldValue }) => (
                    <Form as={FormikForm} size="small" className="CustomeForm" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={4}>
                            <Field name="parent_group" label="Parent Group" component={FormikInputComponent} placeholder="Parent Group" isMandatory={true}></Field>
                            <CommonSelect options={companyOptions} name="cid" classNameGet={"searchType"} isLabel={false} label="RealBooks: Company Name" isTxn='false' isSelection={true} getValue={handleSelectChange} index={0} isDisable={false} defaultTxnType={""} isClearable={true} isMandatory={false} />
                            <Field name="dms_id" component={FormikInputComponent} placeholder="DMS ID" isMandatory={true}></Field>
                        </Form.Group>
                        <Form.Group widths={4}>
                            <Field name="rlb_item_code" component={FormikInputComponent} placeholder="RLB Item Code" readOnly={true} className="readOnly" isMandatory={true}></Field>
                            <ItemNameSearch name='rlb_item_name' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search Item" label='RLB Item Name' className="itemNameSearch" isMandatory={true} getValue={handleRlbItemNameSelection} onBlurFunction={handleRlbItemNameOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/itemmap/edit/:id' || props.match.path === '/itemmap/clone/:id') ? true : false} values={values} cid={values.cid} />
                        </Form.Group>
                        <Form.Group widths={4}>
                            <Field name="rlb_item_group" component={FormikInputComponent} placeholder="RLB Item Group" readOnly={true} className="readOnly" isMandatory={true}></Field>
                            <Field name="uom" component={FormikInputComponent} placeholder="UOM" label="UOM" readOnly={true} className="readOnly" isMandatory={true}></Field>
                        </Form.Group>
                        <Form.Group widths={4}>
                            <LedgerSearch name='item_wise_sale_ledger' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='Item wise Sale Ledger' className="ledgerSearch" isMandatory={false} getValue={handleItemWiseSaleLedgerSelection} onBlurFunction={handleItemWiseSaleLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/itemmap/edit/:id' || props.match.path === '/itemmap/clone/:id') ? true : false} values={values} componentType="itemmapForm" cid={values.cid} />
                            <Field name="item_wise_sale_ledger_cd" component={FormikInputComponent} placeholder="Item wise Sale Ledger Code" label="Item wise Sale Ledger Code" readOnly={true} className="readOnly"></Field>
                        </Form.Group>
                        <Form.Group widths={4}>
                            <LedgerSearch name='item_wise_purchase_ledger' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='Item wise Purchase Ledger' className="ledgerSearch" isMandatory={false} getValue={handleItemWisePurchaseLedgerSelection} onBlurFunction={handleItemWisePurchaseLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/itemmap/edit/:id' || props.match.path === '/itemmap/clone/:id') ? true : false} values={values} componentType="itemmapForm" cid={values.cid} />
                            <Field name="item_wise_purchase_ledger_cd" component={FormikInputComponent} placeholder="Item wise Purchase Ledger Code" label="Item wise Purchase Ledger Code" readOnly={true} className="readOnly"></Field>
                        </Form.Group>
                        <Form.Group widths={4}>
                            <LedgerSearch name='item_wise_sto_ledger' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='Item wise STO Ledger' className="ledgerSearch" isMandatory={false} getValue={handleItemWiseSTOLedgerSelection} onBlurFunction={handleItemWiseSTOLedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/itemmap/edit/:id' || props.match.path === '/itemmap/clone/:id') ? true : false} values={values} componentType="itemmapForm" cid={values.cid} />
                            <Field name="item_wise_sto_ledger_cd" component={FormikInputComponent} placeholder="Item wise STO Ledger Code" label="Item wise STO Ledger Code" readOnly={true} className="readOnly"></Field>
                        </Form.Group>
                        <Form.Group widths={4}>
                            <LedgerSearch name='item_wise_sti_ledger' focus={false} isTxn={true} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='Item wise STI Ledger' className="ledgerSearch" isMandatory={false} getValue={handleItemWiseSTILedgerSelection} onBlurFunction={handleItemWiseSTILedgerOnBlur} onKeyUpFunction={null} isEditMode={(props.match.path === '/itemmap/edit/:id' || props.match.path === '/itemmap/clone/:id') ? true : false} values={values} componentType="itemmapForm" cid={values.cid} />
                            <Field name="item_wise_sti_ledger_cd" component={FormikInputComponent} placeholder="Item wise STI Ledger Code" label="Item wise STI Ledger Code" readOnly={true} className="readOnly"></Field>
                        </Form.Group>
                        <Button type="submit" size="medium blue" className="CustomeBTN"> {params.submitButtonText} </Button>
                        {savedItemmapId ?
                            <Notification id={savedItemmapId} resetForm={resetForm} notifySelector={getNotification} notifyDoneAction={setNotifyDone} type='save' />
                            :
                            null}
                    </Form>
                )}
            />
        </>
    )
}

export default ItemmapForm;